const baseStyle = () => {
  return {
    py: 4,
    px: 4,
    maxWidth: 350,
    shadow: 1,
    rounded: 'sm',
    _title: {
      fontSize: 'md',
      lineHeight: 'md',
      fontWeight: '600',
      mb: 1,
    },
    _text: {
      fontSize: 'md',
      lineHeight: 'md',
    },
    _light: {
      bg: `white`,
      _text: {
        color: `darkText`,
      },
    },
    _dark: {
      bg: `white`,
      _text: {
        color: `darkText`,
      },
    },
  };
};

export const Tooltip = {
  baseStyle,
};
